// extracted by mini-css-extract-plugin
export default {"inner":"B_inner__6aip2","outer":"B_outer__7YnbK","inner1":"B_inner1__kCM3h","inner2":"B_inner2__IrgqF","wrapper":"B_wrapper__40mBa"};